import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, TEMPLATE_RESOLVERS } from 'cpool-constants';
import { schemaTemplateResolver_GetStatusesWithDivisionMailTrigger } from 'cpool-tables/backend-resolvers';

import useUserInfo from '~/hooks/useUserInfo.tsx';
import { useAggregateQuery } from '~/queryUtils/useQuery.ts';

export const useLoanRequestStatusesWithMailTrigger = () => {
    const user = useUserInfo();
    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.TEMPLATE,
        resolverName: TEMPLATE_RESOLVERS.getStatusesWithDivisionMailTrigger,
        schema: schemaTemplateResolver_GetStatusesWithDivisionMailTrigger,
        searchParams: { divisionId: user?.divisionId ?? null },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
